import { render } from "./HeadingWithParagraph.vue?vue&type=template&id=c1d9d03a&scoped=true"
import script from "./HeadingWithParagraph.vue?vue&type=script&lang=js"
export * from "./HeadingWithParagraph.vue?vue&type=script&lang=js"

import "./HeadingWithParagraph.vue?vue&type=style&index=0&id=c1d9d03a&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d9d03a"]])

export default __exports__